export const pets = [
  {
    id: 'p1',
    name: 'Apollo',
    type: 'Dog',
    breed: 'Golden Retriever',
    age: '3 yrs',
    weight: '32 kg',
    image: 'https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&q=80&w=400&h=400',
    status: 'Ready for walk',
    vitality: 95,
    lastMeal: '08:00 AM',
    nextTask: 'Orbital Walk',
    chipId: 'OP-7729-ALPHA'
  },
  {
    id: 'p2',
    name: 'Luna',
    type: 'Cat',
    breed: 'Siamese',
    age: '2 yrs',
    weight: '4.5 kg',
    image: 'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?auto=format&fit=crop&q=80&w=400&h=400',
    status: 'Sleeping',
    vitality: 88,
    lastMeal: '07:30 AM',
    nextTask: 'Vet Checkup',
    chipId: 'OP-1104-LUNA'
  },
  {
    id: 'p3',
    name: 'Ziggy',
    type: 'Bird',
    breed: 'Cockatiel',
    age: '1 yr',
    weight: '0.1 kg',
    image: 'https://images.unsplash.com/photo-1522856339183-5a983baf28f9?auto=format&fit=crop&q=80&w=400&h=400',
    status: 'Chirping',
    vitality: 100,
    lastMeal: '09:00 AM',
    nextTask: 'Flight Practice',
    chipId: 'OP-0092-ZIG'
  },
  {
    id: 'p4',
    name: 'Nova',
    type: 'Dog',
    breed: 'Husky',
    age: '4 yrs',
    weight: '24 kg',
    image: 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?auto=format&fit=crop&q=80&w=400&h=400',
    status: 'Alert',
    vitality: 92,
    lastMeal: '06:00 AM',
    nextTask: 'Training Prep',
    chipId: 'OP-8831-NOVA'
  }
];

export const schedule = [
  { id: 's1', petId: 'p1', type: 'feeding', title: 'Morning Rations', time: '08:00 AM', completed: true, icon: 'FiCoffee' },
  { id: 's2', petId: 'p1', type: 'activity', title: 'Orbital Walk', time: '09:30 AM', completed: true, icon: 'FiMap' },
  { id: 's3', petId: 'p2', type: 'medical', title: 'Vet Checkup', time: '02:00 PM', completed: false, icon: 'FiActivity' },
  { id: 's4', petId: 'all', type: 'feeding', title: 'Evening Rations', time: '06:00 PM', completed: false, icon: 'FiMoon' },
  { id: 's5', petId: 'p3', type: 'training', title: 'Flight Practice', time: '07:00 PM', completed: false, icon: 'FiWind' },
  { id: 's6', petId: 'p1', type: 'medical', title: 'Flea Treatment', time: '08:00 PM', completed: false, icon: 'FiShield' },
];

export const supplies = [
  { id: 'sup1', name: 'Premium Kibble', category: 'Food', remaining: 35, unit: '%', status: 'low', color: '#FF7F50' },
  { id: 'sup2', name: 'Flea Medication', category: 'Medical', remaining: 80, unit: '%', status: 'good', color: '#0047AB' },
  { id: 'sup3', name: 'Cat Litter', category: 'Hygiene', remaining: 15, unit: '%', status: 'critical', color: '#EF4444' },
  { id: 'sup4', name: 'Training Treats', category: 'Food', remaining: 60, unit: '%', status: 'good', color: '#10B981' },
  { id: 'sup5', name: 'Dental Sticks', category: 'Health', remaining: 10, unit: '%', status: 'critical', color: '#F59E0B' },
];

export const trainingLogs = [
  { id: 't1', petId: 'p1', skill: 'Recall', level: 'Advanced', status: 'Mastered', progress: 100 },
  { id: 't2', petId: 'p1', skill: 'Leash Walking', level: 'Intermediate', status: 'In Progress', progress: 65 },
  { id: 't3', petId: 'p3', skill: 'Target Touch', level: 'Beginner', status: 'Started', progress: 20 },
];

export const photoMoments = [
  { id: 'm1', url: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&q=80&w=800', caption: 'Morning Solar Patrol', date: 'Today' },
  { id: 'm2', url: 'https://images.unsplash.com/photo-1533738363-b7f9aef128ce?auto=format&fit=crop&q=80&w=800', caption: 'Luna in Deep Sleep Orbit', date: 'Yesterday' },
  { id: 'm3', url: 'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&q=80&w=800', caption: 'Apollo Ground Training', date: '2 days ago' },
  { id: 'm4', url: 'https://images.unsplash.com/photo-1535930891776-0c2dfb7fda1a?auto=format&fit=crop&q=80&w=800', caption: 'Nova Sector Scanning', date: '3 days ago' },
  { id: 'm5', url: 'https://images.unsplash.com/photo-1504595403659-9088ce801e29?auto=format&fit=crop&q=80&w=800', caption: 'Afternoon Rest Protocol', date: '4 days ago' },
  { id: 'm6', url: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?auto=format&fit=crop&q=80&w=800', caption: 'Training Drill Complete', date: '5 days ago' },
];

export const sitterNotes = [
  { id: 'n1', author: 'Sarah (Sitter)', date: 'Today, 10:00 AM', text: 'Apollo was full of energy today! We played fetch for 30 mins.' },
  { id: 'n2', author: 'System', date: 'Yesterday', text: 'Luna skipped her afternoon snack. Monitoring intake.' },
  { id: 'n3', author: 'Marcus (Vet)', date: '2 days ago', text: 'Ziggy looks great. Feathers are in perfect condition.' }
];

export const activityData = {
  categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  series: [
    { name: 'Apollo', data: [120, 132, 101, 134, 90, 230, 210] },
    { name: 'Luna', data: [45, 50, 48, 52, 40, 60, 55] }
  ]
};

export const demoWorkflow = [
  {
    step: 1,
    title: "Crew Onboarding",
    description: "Initialize your pet's bio-profile, including breed, age, and weight parameters.",
    module: "Pet Profiles",
    icon: "FiUserPlus",
    detail: "A successful mission begins with accurate crew data. Log vitality baselines to track health over time."
  },
  {
    step: 2,
    title: "Protocol Scheduling",
    description: "Establish feeding, medication, and activity routines on the Mission Timeline.",
    module: "Timeline",
    icon: "FiCalendar",
    detail: "Eliminate care confusion. All pet parents see the same live schedule, preventing double-feeding or missed meds."
  },
  {
    step: 3,
    title: "Cargo Inventory",
    description: "Scan and log essential supplies to prevent critical mission shortages.",
    module: "Supplies",
    icon: "FiBox",
    detail: "Automated alerts trigger when your kibble or medicine 'cargo' drops below 20% capacity."
  },
  {
    step: 4,
    title: "Skill Uplink",
    description: "Record daily training drills and track behavioral proficiency levels.",
    module: "Training",
    icon: "FiZap",
    detail: "Visualize progress from 'Beginner' to 'Mastered' as your crew learns new orbital commands."
  },
  {
    step: 5,
    title: "Ground Crew Handover",
    description: "Generate secure handover notes for temporary sitters or walkers.",
    module: "Sitter Notes",
    icon: "FiMessageSquare",
    detail: "Leave precise instructions for specific behaviors or medical needs. Real-time logging lets you see their updates from anywhere."
  },
  {
    step: 6,
    title: "Moment Archiving",
    description: "Capture and store high-resolution visual logs of your crew's journey.",
    module: "Moments",
    icon: "FiCamera",
    detail: "A private visual legacy of your pets' lives, synchronized across devices for all family members."
  }
];

export const faqs = [
  {
    q: "How does PetOrbit coordinate multiple caregivers?",
    a: "PetOrbit uses a synchronized 'Mission Control' architecture. When one pet parent logs a feeding or walk, the timeline updates instantly for everyone else on the crew, preventing duplicate tasks."
  },
  {
    q: "Can I manage different types of pets?",
    a: "Absolutely. Whether it's a dog, cat, bird, or exotic 'crew member,' PetOrbit allows for custom vitality metrics and specific mission protocols tailored to each species."
  },
  {
    q: "Is my pet's data private?",
    a: "Yes. PetOrbit is designed as a secure environment. Your pet's medical records, location logs, and photo moments are only accessible to invited 'Pet Parents' and authorized 'Ground Crew' (sitters)."
  },
  {
    q: "How do the cargo alerts work?",
    a: "As you log usage, PetOrbit tracks remaining inventory. When levels hit the 'Critical' threshold (default 15%), the system sends a high-priority notification to restock your cargo."
  },
  {
    q: "What is the 'Handover' feature?",
    a: "The Handover feature allows you to create a temporary access profile for sitters. They can see the timeline and log notes without needing full administrative access to your pet's settings."
  }
];